import { Item, StyledItems } from '@/scenes/Gallery/Items/styles';
import { inject, observer } from 'mobx-react';
import { IGalleryStore } from '@/stores/Gallery';
import { FC } from 'react';
import { BearCard } from '@/components/Bear';

interface GalleryItemsProps {
  galleryStore: IGalleryStore;
}

const GalleryItems: FC<any> = ({ galleryStore }: GalleryItemsProps) => {
  const { bears } = galleryStore;

  if (!bears.length) return null;

  return (
    <StyledItems>
      {bears.map((bear) => (
        <Item key={bear.identifier}>
          <BearCard bear={bear} />
        </Item>
      ))}
    </StyledItems>
  );
};

export default inject('galleryStore')(observer(GalleryItems));
